import { render } from "./TheFinancePaydesk.vue?vue&type=template&id=1ea354f3&scoped=true"
import script from "./TheFinancePaydesk.vue?vue&type=script&lang=js"
export * from "./TheFinancePaydesk.vue?vue&type=script&lang=js"

import "./TheFinancePaydesk.vue?vue&type=style&index=0&id=1ea354f3&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ea354f3"]])

export default __exports__